import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsMedal03Small = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4.583 12.997l-2.704-2.704A3 3 0 011 8.172V3a3 3 0 013-3h16a3 3 0 013 3v5.172a3 3 0 01-.879 2.12l-2.704 2.705a8 8 0 11-14.835 0zM4 2a.998.998 0 00-.749.337L4.914 4h14.172l1.663-1.663A.997.997 0 0020 2zm5.36 6.446C10.187 8.157 11.075 8 12 8s1.813.157 2.64.446L17.086 6H6.914zm-1.878.95L3 4.915v3.258a1 1 0 00.293.707l2.313 2.313a8.044 8.044 0 011.876-1.795zm10.912 1.796l2.313-2.313A1 1 0 0021 8.172V4.914l-4.483 4.483a8.041 8.041 0 011.877 1.795zM9 14h3.5a.5.5 0 010 1H11v2h1.5a.5.5 0 010 1H9a2 2 0 002 2h1.5a2.5 2.5 0 002-4 2.5 2.5 0 00-2-4H11a2 2 0 00-2 2z"
        fill=""
      />
    </svg>
  )
);
SvgAchievementsMedal03Small.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsMedal03Small;
